export const STORE_LANGUAGES_LIST = 'STORE_LANGUAGES'
export const STORE_LANGUAGE_STATE = 'STORE_LANGUAGE'
export const UPDATE_COURSES_LOADING = 'UPDATE_COURSES_LOADING_LIST'
export const UPDATE_COURSES_TYPE = 'UPDATE_COURSES_TYPE'
export const UPDATE_COURSE_ID = 'UPDATE_COURSE_ID'
export const UPDATE_COURSES_SEARCH_TERM = 'UPDATE_COURSES_SEARCH_TERM'
export const UPDATE_COURSES_ACTIVE_RETURN = 'UPDATE_COURSES_ACTIVE_RETURN'
